import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericSimpleButton, GenericModalButton  } from 'com-gyf-webcore-userinterfacecomponents';

const Footer = (props) => {
    let component;
    if (props.usuariosSeleccionados.length > 0 ||
        props.perfilesSeleccionados.length > 0 ||
        (props.permisos.length > 0 && props.permisos[0].funciones.length > 0)) {
        component = <GenericModalButton text="Cancelar" buttonClass="btn btn-secondary" dataTarget="#confirm-cancel" />;
    }
    else {
        component =
            <Link to={ProcessManager.GetNextStep("PermisosMasivos", "ROUTE_TO_PERFYPERM")}>
                <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" />
            </Link>;
    }

    return (
        <div className="row">
            <div className="col-xs-2">
                <GenericSimpleButton text="Guardar" buttonClass="btn btn-cta" onClick={() => props.savePermisos()} />
            </div>
            <div className="col-xs-2">
                {component}
            </div>
        </div>
    );
};

export default Footer;